module.exports = __webpack_public_path__ + "static/portico_bg-11da336909a1a82d6335ba297b88c496.jpg";